import { render } from "./water-drop.svg?vue&type=template&id=1ad97090?inline"
const script = {}
script.render = render

export default script